import { render, staticRenderFns } from "./payment-recipient-form.vue?vue&type=template&id=0d9226f8&"
import script from "./payment-recipient-form.vue?vue&type=script&lang=js&"
export * from "./payment-recipient-form.vue?vue&type=script&lang=js&"
import style0 from "./payment-recipient-form.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports